import Link from 'next/link';

interface CookieContentProps {
  isCookieConsentAllowed: boolean | undefined;
}

interface CookieTextWrapperProps {
  children: React.ReactNode;
}

const CookiesPolicyLink: React.FC = () => {
  return (
    <Link href='/privacy-policy' className='underline underline-offset-4'>
      Cookies Policy.
    </Link>
  );
};

const CookieTextWrapper: React.FC<CookieTextWrapperProps> = ({ children }: CookieTextWrapperProps) => {
  return <p className='text-lg lg:text-xl text-text-primary leading-tight'>{children}</p>;
};

const CookieContent: React.FC<CookieContentProps> = ({ isCookieConsentAllowed }: CookieContentProps) => {
  if (isCookieConsentAllowed === undefined) {
    return (
      <CookieTextWrapper>
        <span>
          We care about your data, and with your consent, we will only use cookies to <span className='font-bold'>improve</span> your
          experience. Learn more about our
        </span>{' '}
        <CookiesPolicyLink />
      </CookieTextWrapper>
    );
  }

  return (
    <CookieTextWrapper>
      <span>
        This Website Requires Cookies to properly <span className='font-bold'>Operate</span>. Learn more about our
      </span>{' '}
      <CookiesPolicyLink /> <span>If you do not agree, clicking &quot;Don&apos;t allow&quot; will redirect you away from this page.</span>
    </CookieTextWrapper>
  );
};

export default CookieContent;
